import {
  SearchableWorkflowFilterInput,
  WorkflowStatus,
  WorkflowTriggerSource
} from 'generated-graphql/hooks/apollo-hooks';

type BuildInternalSourcingWorkflowFilterProps = {
  organizationId: string;
  searchQuery?: string;
  /** Narrows to one workflow, for resolving a preselection without loosening eligibility. */
  workflowId?: string;
};

/**
 * The workflows a recruiter may push internally-sourced candidates into: published, and
 * declaring an internal-sourcing entry on their live version.
 *
 * `entrySources` is a list on the model, and OpenSearch matches any element, so `eq` reads as
 * "contains". It is a projection written at publish — the workflow's frozen entry pathways stay
 * the authority, and workflow-service rejects a push to a workflow that doesn't accept one.
 */
export const buildInternalSourcingWorkflowFilter = ({
  organizationId,
  searchQuery,
  workflowId
}: BuildInternalSourcingWorkflowFilterProps): SearchableWorkflowFilterInput => ({
  and: [
    { organizationId: { eq: organizationId } },
    { status: { eq: WorkflowStatus.Published } },
    { entrySources: { eq: WorkflowTriggerSource.InternalSourcing } },
    ...(workflowId ? [{ id: { eq: workflowId } }] : []),
    // matchPhrasePrefix, not wildcard: `name` is an analysed text field, so a wildcard is
    // matched per token and a pattern containing a space can never hit — "qa engineer"
    // returned nothing while "qa" worked. This matches across tokens and treats the last
    // word as a prefix, which is what a type-ahead needs. The analyser handles casing.
    ...(searchQuery ? [{ name: { matchPhrasePrefix: searchQuery } }] : [])
  ]
});
